






import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class Clock extends Vue {
  clockTime: string = "";

  mounted(): void {
    this.startTime();
  }

  startTime() {
    var today = new Date();

    this.clockTime =
      today.getHours() +
      ":" +
      this.formatNumber(today.getMinutes()) +
      ":" +
      this.formatNumber(today.getSeconds());

    const vm = this;
    let t = setTimeout(function() {
      vm.startTime();
    }, 500);
  }

  formatNumber(i: number): string {
    return i.toString().padStart(2, "0");
  }
}
